import Excel from 'exceljs';
import FileSaver from 'file-saver';
import dayjs from 'dayjs';
import { SalesSummaryPageQuery } from '../../../../services';

// One row per request product line (a product within a pedido): what that pedido
// requested versus what has been sold against it. Same per-line grain and
// leading Cliente / Año / Mes columns as the sales export, so the two reports
// line up; "Pendientes" is requested - sold (negative = over-sold).
export async function downloadOrderRequestSummaryReport(
    records?: SalesSummaryPageQuery['getOrderRequestSummary']['records'],
) {
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet();
    ws.addRow([
        'Pedido',
        'Cliente',
        'Año',
        'Mes',
        'Mes 2',
        'Día',
        'Producto',
        'Material',
        'Ancho',
        'Largo',
        'Calibre',
        'Kilos solicitados',
        'Kilos vendidos',
        'Kilos pendientes',
        'Bultos solicitados',
        'Bultos vendidos',
        'Bultos pendientes',
    ]);
    records?.forEach((record) => {
        // Calendar date stamped at midnight UTC: read it as UTC (like formatDate)
        // or Mexico's offset shifts it to the previous day — and, on the 1st, to
        // the previous month.
        const date = record.date ? dayjs.utc(record.date) : null;
        ws.addRow([
            record.order_code,
            record.account_name,
            date ? date.year() : '',
            date ? date.format('MMMM') : '',
            date ? date.month() + 1 : '',
            date ? date.date() : '',
            record.product_name,
            record.product_material_name,
            record.width,
            record.length,
            record.calibre,
            record.kilos_requested,
            record.kilos_sold,
            record.kilos_requested - record.kilos_sold,
            record.groups_requested,
            record.groups_sold,
            record.groups_requested - record.groups_sold,
        ]);
    });

    ws.columns.forEach((column, index) => {
        let maxColumnLength = 6;
        if (column.eachCell) {
            column.eachCell({ includeEmpty: true }, (cell) => {
                maxColumnLength = Math.max(
                    maxColumnLength,
                    cell.value ? cell.value.toString().length : 0,
                );
            });
        }
        ws.getColumn(index + 1).width = maxColumnLength;
    });
    ws.getColumn(9).alignment = { horizontal: 'right' };

    const buffer = await workbook.xlsx.writeBuffer();
    FileSaver.saveAs(new Blob([buffer]), 'pedidos-solicitado-vs-vendido.xlsx');
}
